// extracted by css-extract-rspack-plugin
export default {"root":"src-wab-client-plasmic-plasmic_kit_pricing-PlasmicHoverableIcon-module__root-zBm6pB","svg":"src-wab-client-plasmic-plasmic_kit_pricing-PlasmicHoverableIcon-module__svg-o6XpZd","svgwhite":"src-wab-client-plasmic-plasmic_kit_pricing-PlasmicHoverableIcon-module__svgwhite-alEcKK","slotTargetPopover":"src-wab-client-plasmic-plasmic_kit_pricing-PlasmicHoverableIcon-module__slotTargetPopover-TVAMMp"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-wab-client-plasmic-plasmic_kit_pricing-PlasmicHoverableIcon-module__root-zBm6pB\",\"svg\":\"src-wab-client-plasmic-plasmic_kit_pricing-PlasmicHoverableIcon-module__svg-o6XpZd\",\"svgwhite\":\"src-wab-client-plasmic-plasmic_kit_pricing-PlasmicHoverableIcon-module__svgwhite-alEcKK\",\"slotTargetPopover\":\"src-wab-client-plasmic-plasmic_kit_pricing-PlasmicHoverableIcon-module__slotTargetPopover-TVAMMp\"}";
        // 1793541991022
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  